import {IToggleCollapseAction} from './types/sidebar.types';

export const TOGGLE_COLLAPSE = 'TOGGLE_COLLAPSE';

export const toggleCollapseAction = (): IToggleCollapseAction => ({
    type: TOGGLE_COLLAPSE,
});

export type SidebarReducerType = IToggleCollapseAction;
